import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, Transition as _Transition, withCtx as _withCtx, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-background font-inter text-foreground" }
const _hoisted_2 = { class: "sticky top-0 z-40 border-b border-border bg-background/80 backdrop-blur" }
const _hoisted_3 = { class: "mx-auto max-w-7xl px-4 py-3 flex items-center justify-between gap-4" }
const _hoisted_4 = { class: "flex items-center gap-3" }
const _hoisted_5 = {
  class: "text-xs text-muted-foreground",
  "aria-live": "polite"
}
const _hoisted_6 = { class: "flex items-center gap-2" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "flex items-center gap-2"
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  class: "flex items-center gap-2"
}
const _hoisted_13 = { class: "mx-auto max-w-7xl px-4 py-8 grid grid-cols-1 lg:grid-cols-[260px,1fr] gap-8" }
const _hoisted_14 = {
  key: 0,
  class: "lg:sticky lg:top-[72px] self-start space-y-6"
}
const _hoisted_15 = { class: "rounded-lg border border-border bg-card p-4" }
const _hoisted_16 = { class: "flex items-center justify-between" }
const _hoisted_17 = { class: "text-xs text-muted-foreground" }
const _hoisted_18 = { class: "mt-3 h-2 w-full rounded-full bg-muted/40 overflow-hidden" }
const _hoisted_19 = {
  key: 0,
  class: "mt-3 space-y-2 text-xs"
}
const _hoisted_20 = { class: "flex items-center gap-2" }
const _hoisted_21 = {
  key: 0,
  class: "ml-6 space-y-1"
}
const _hoisted_22 = { class: "space-y-1" }
const _hoisted_23 = { class: "text-[11px] font-medium text-foreground" }
const _hoisted_24 = {
  key: 0,
  class: "text-[11px] text-red-600"
}
const _hoisted_25 = {
  key: 1,
  class: "text-[11px] text-muted-foreground"
}
const _hoisted_26 = {
  key: 1,
  class: "mt-4 text-[11px] text-red-600"
}
const _hoisted_27 = {
  key: 2,
  class: "mt-4 text-[11px] text-muted-foreground"
}
const _hoisted_28 = {
  key: 1,
  class: "lg:sticky lg:top-[72px] self-start space-y-6 animate-pulse"
}
const _hoisted_29 = {
  key: 2,
  class: "space-y-8"
}
const _hoisted_30 = {
  id: "sec-details",
  class: "rounded-lg border border-border bg-card p-6"
}
const _hoisted_31 = { class: "flex items-center gap-5" }
const _hoisted_32 = { class: "w-28 h-28 rounded-lg bg-muted flex items-center justify-center overflow-hidden border border-border" }
const _hoisted_33 = ["src"]
const _hoisted_34 = {
  key: 1,
  class: "text-xs text-muted-foreground"
}
const _hoisted_35 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_36 = { class: "block md:col-span-2" }
const _hoisted_37 = { class: "block" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = ["value"]
const _hoisted_40 = {
  key: 0,
  class: "block"
}
const _hoisted_41 = ["value"]
const _hoisted_42 = { class: "block" }
const _hoisted_43 = ["value"]
const _hoisted_44 = { class: "block" }
const _hoisted_45 = { class: "block" }
const _hoisted_46 = { class: "block" }
const _hoisted_47 = { class: "block" }
const _hoisted_48 = { class: "block md:col-span-2" }
const _hoisted_49 = { class: "block md:col-span-2" }
const _hoisted_50 = {
  id: "sec-profile",
  class: "rounded-lg border border-border bg-card p-6 mt-8"
}
const _hoisted_51 = { class: "mb-8" }
const _hoisted_52 = { class: "space-y-3" }
const _hoisted_53 = { class: "grid gap-2 sm:grid-cols-[repeat(4,minmax(0,1fr))] sm:items-start" }
const _hoisted_54 = ["onUpdate:modelValue"]
const _hoisted_55 = ["onUpdate:modelValue"]
const _hoisted_56 = ["onUpdate:modelValue"]
const _hoisted_57 = {
  key: 0,
  class: "mt-3 flex justify-end"
}
const _hoisted_58 = ["onClick"]
const _hoisted_59 = { class: "mb-8" }
const _hoisted_60 = { class: "space-y-3" }
const _hoisted_61 = { class: "grid gap-3 md:grid-cols-2" }
const _hoisted_62 = ["onUpdate:modelValue"]
const _hoisted_63 = ["onUpdate:modelValue"]
const _hoisted_64 = ["onUpdate:modelValue"]
const _hoisted_65 = ["onUpdate:modelValue"]
const _hoisted_66 = ["onUpdate:modelValue"]
const _hoisted_67 = ["onUpdate:modelValue"]
const _hoisted_68 = { class: "flex justify-end" }
const _hoisted_69 = ["onClick"]
const _hoisted_70 = {
  key: 0,
  class: "mb-8"
}
const _hoisted_71 = { class: "mt-3 flex flex-wrap gap-2" }
const _hoisted_72 = ["onClick"]
const _hoisted_73 = {
  key: 2,
  class: "mb-8"
}
const _hoisted_74 = { class: "space-y-3" }
const _hoisted_75 = { class: "flex flex-col sm:flex-row gap-2" }
const _hoisted_76 = ["onUpdate:modelValue"]
const _hoisted_77 = ["onUpdate:modelValue"]
const _hoisted_78 = ["value"]
const _hoisted_79 = ["onClick"]
const _hoisted_80 = ["onUpdate:modelValue"]
const _hoisted_81 = ["onUpdate:modelValue"]
const _hoisted_82 = { class: "space-y-2 rounded-md border border-border/60 bg-white/70 p-3" }
const _hoisted_83 = { class: "flex items-center justify-between gap-2" }
const _hoisted_84 = ["onClick"]
const _hoisted_85 = ["onUpdate:modelValue"]
const _hoisted_86 = ["onUpdate:modelValue"]
const _hoisted_87 = ["onClick"]
const _hoisted_88 = { class: "flex flex-wrap gap-2" }
const _hoisted_89 = ["onClick"]
const _hoisted_90 = { class: "mb-8" }
const _hoisted_91 = { class: "space-y-4" }
const _hoisted_92 = { class: "flex items-center justify-between gap-3" }
const _hoisted_93 = { class: "text-sm font-medium text-foreground" }
const _hoisted_94 = { class: "rounded-full bg-muted px-2.5 py-1 text-[11px] font-medium uppercase tracking-[0.14em] text-muted-foreground" }
const _hoisted_95 = ["value", "placeholder", "onInput"]
const _hoisted_96 = { class: "mt-2 text-xs text-muted-foreground" }
const _hoisted_97 = { key: 3 }
const _hoisted_98 = { class: "grid grid-cols-1 gap-4" }
const _hoisted_99 = { class: "flex items-center justify-between rounded-lg border border-border bg-muted/10 px-4 py-3" }
const _hoisted_100 = { class: "relative inline-flex items-center cursor-pointer" }
const _hoisted_101 = { class: "block" }
const _hoisted_102 = { class: "relative mt-1" }
const _hoisted_103 = ["disabled"]
const _hoisted_104 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 animate-spin text-brand"
}
const _hoisted_105 = {
  key: 0,
  class: "mt-1 text-xs text-red-600"
}
const _hoisted_106 = {
  key: 1,
  class: "mt-1 text-xs text-muted-foreground"
}
const _hoisted_107 = {
  key: 0,
  class: "block"
}
const _hoisted_108 = { class: "mt-1 w-full rounded-md border border-border bg-muted/30 px-3 py-2 text-sm text-foreground" }
const _hoisted_109 = { class: "block" }
const _hoisted_110 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_111 = { class: "block" }
const _hoisted_112 = {
  key: 0,
  class: "mt-1 text-xs text-red-600"
}
const _hoisted_113 = { class: "mt-6" }
const _hoisted_114 = { class: "space-y-3" }
const _hoisted_115 = { class: "grid gap-3 md:grid-cols-2" }
const _hoisted_116 = { class: "block" }
const _hoisted_117 = ["onUpdate:modelValue"]
const _hoisted_118 = { class: "block" }
const _hoisted_119 = ["onUpdate:modelValue", "onInput"]
const _hoisted_120 = { class: "block" }
const _hoisted_121 = ["onUpdate:modelValue"]
const _hoisted_122 = { class: "block" }
const _hoisted_123 = ["onUpdate:modelValue"]
const _hoisted_124 = { class: "block md:col-span-2" }
const _hoisted_125 = ["onUpdate:modelValue"]
const _hoisted_126 = { class: "flex justify-end" }
const _hoisted_127 = ["onClick"]
const _hoisted_128 = { class: "mt-6" }
const _hoisted_129 = { class: "space-y-3" }
const _hoisted_130 = { class: "grid gap-3 md:grid-cols-2" }
const _hoisted_131 = { class: "block" }
const _hoisted_132 = ["onUpdate:modelValue"]
const _hoisted_133 = { class: "block" }
const _hoisted_134 = ["onUpdate:modelValue"]
const _hoisted_135 = { class: "block md:col-span-2" }
const _hoisted_136 = ["onUpdate:modelValue"]
const _hoisted_137 = {
  key: 0,
  class: "text-xs text-muted-foreground"
}
const _hoisted_138 = { class: "flex justify-end" }
const _hoisted_139 = ["onClick"]
const _hoisted_140 = {
  id: "sec-operations",
  "aria-labelledby": "sec-operations-title",
  class: "rounded-lg border border-border bg-card p-6"
}
const _hoisted_141 = { class: "mt-4 grid gap-4" }
const _hoisted_142 = {
  key: 0,
  class: "block"
}
const _hoisted_143 = { class: "block" }
const _hoisted_144 = {
  key: 1,
  class: "block"
}
const _hoisted_145 = { class: "rounded-lg border border-border bg-card p-6" }
const _hoisted_146 = { class: "space-y-4" }
const _hoisted_147 = { class: "text-sm font-medium text-foreground" }
const _hoisted_148 = ["value", "placeholder", "onInput"]
const _hoisted_149 = { class: "mt-2 text-xs text-muted-foreground" }
const _hoisted_150 = {
  key: 3,
  class: "space-y-8 animate-pulse"
}
const _hoisted_151 = {
  key: 0,
  class: "pointer-events-none fixed inset-x-0 top-4 z-[999] flex justify-center px-4"
}
const _hoisted_152 = {
  class: "pointer-events-auto relative flex w-full max-w-xl gap-4 rounded-2xl border border-border/60 bg-background/95 p-5 shadow-xl shadow-brand/10 backdrop-blur-md ring-1 ring-brand/10",
  role: "alert",
  "aria-live": "assertive"
}
const _hoisted_153 = { class: "flex h-12 w-12 items-center justify-center rounded-full bg-brand/10 text-brand" }
const _hoisted_154 = { class: "flex-1 text-left" }
const _hoisted_155 = { class: "text-sm font-semibold text-foreground" }
const _hoisted_156 = { class: "mt-1 text-sm text-muted-foreground" }
const _hoisted_157 = {
  key: 0,
  class: "mt-3 flex flex-wrap gap-2"
}
const _hoisted_158 = ["onClick"]
const _hoisted_159 = { class: "flex flex-col items-end gap-3 text-right" }
const _hoisted_160 = { class: "w-full max-w-md rounded-lg border border-border bg-card shadow-2xl" }
const _hoisted_161 = { class: "px-6 py-5" }
const _hoisted_162 = {
  key: 0,
  class: "mt-3 text-sm text-red-500"
}
const _hoisted_163 = { class: "flex items-center justify-end gap-3 border-t border-border bg-muted/20 px-6 py-4" }
const _hoisted_164 = ["disabled"]
const _hoisted_165 = ["disabled"]
const _hoisted_166 = { class: "w-full max-w-xl rounded-lg border border-border bg-card shadow-2xl" }
const _hoisted_167 = { class: "px-6 py-5" }
const _hoisted_168 = { class: "flex items-center gap-3" }
const _hoisted_169 = { class: "flex h-10 w-10 items-center justify-center rounded-full bg-brand/10 text-brand" }
const _hoisted_170 = { class: "mt-4 space-y-2 rounded-md border border-border/60 bg-background/60 p-4 text-sm text-muted-foreground" }
const _hoisted_171 = { class: "flex items-center gap-2" }
const _hoisted_172 = { class: "flex items-center gap-2" }
const _hoisted_173 = {
  key: 0,
  class: "mt-3 text-sm text-red-500"
}
const _hoisted_174 = { class: "flex items-center justify-end gap-3 border-t border-border bg-muted/20 px-6 py-4" }
const _hoisted_175 = ["disabled"]
const _hoisted_176 = ["disabled"]

import { ref, computed, onMounted, toRef, toRaw, onBeforeUnmount } from 'vue'
import { storeToRefs } from 'pinia'

import { useSaveStatus } from '@/composables/useSaveStatus'
import SaveStatusToast from '@/components/marketplace/company/profile/SaveStatusToast.vue'
import ProfileLogoUploader from '@/components/marketplace/company/profile/ProfileLogoUploader.vue'
import { useCompanyProfile } from '@/composables/useCompanyProfile'
import { useCompanyProfileForm } from '@/composables/useCompanyProfileForm'
import { useIndustryStore } from '@/stores/industryStore'
import { useCompanyIndustryProfileStore } from '@/stores/companyIndustryProfileStore'
import { useCompanyMarketData } from '@/composables/useCompanyMarketData'
import { getCompanyIndustryOptions, getCompanyMarketData } from '@/api/company/profile'
import { EMPLOYEE_SIZES, COMMODITIES, PROJECT_STAGES, SOFTWARE_LOOKUPS } from '@/constants/lookups'
import { formatDateAsDayMonthYear } from '@/utils/formatters'
import type { CompanyIndustryAttributes, CompanyIndustryOption, CompanyIndustrySubcategory } from '@/types/company'
import { CheckCircle2, Circle, AlertCircle, Sparkles, ArrowRight, X, Loader2 } from 'lucide-vue-next'
import TagAutocomplete from '@/components/inputs/TagAutocomplete.vue'
import GoogleMap from '@/components/marketplace/generic/GoogleMap.vue'
import IndustryAttributeFields from '@/components/marketplace/company/IndustryAttributeFields.vue'
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'

type PublishNoticeChip = {
  id: string
  label: string
  anchor?: string
}

type PublishNoticeState = {
  headline: string
  message: string
  chips: PublishNoticeChip[]
  primaryAnchor?: string
}

type JobLinkType = 'linkedin' | 'seek' | 'other'
type SocialLinkType = 'linkedin' | 'facebook' | 'instagram' | 'x' | 'youtube'

const SHOW_NOTICE_DURATION = 7000


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileEdit',
  setup(__props) {

const industryStore = useIndustryStore()
const { industries, isLoading: isLoadingIndustries } = storeToRefs(industryStore)
const industryProfileStore = useCompanyIndustryProfileStore()
const companyIndustryOptions = ref<CompanyIndustryOption[]>([])

const { profile, loadProfile, saveDraft, discardDraft, publishProfile, isLoading, error } =
  useCompanyProfile()
const {
  form,
  isDirty,
  resetForm,
  validationErrors,
  isPublishAttempted,
  validateForPublish,
  preparePublishPayload,
  clearValidationState,
  getFirstErrorForFields,
  checklistSections,
  checklistProgress,
  isChecklistReady,
  industryProfile,
} = useCompanyProfileForm()
// const { saveStatus, triggerAutosave } = useSaveStatus()

// const { saveStatus, triggerAutosave } = useSaveStatus(() => saveDraft(form))
const { saveStatus, triggerAutosave } = useSaveStatus(async () => {
  await saveDraft({ ...toRaw(form) })
})

const statusLabel = computed(() => {
  switch (saveStatus.value) {
    case 'unsaved':
      return 'Unsaved changes'
    case 'saving':
      return 'Saving…'
    case 'error':
      return 'Save failed'
    default:
      return 'All changes saved'
  }
})

const hasDraft = computed(() => profile.value?.is_draft === true)
const isAutosavePending = computed(() => saveStatus.value === 'unsaved' || saveStatus.value === 'saving')
const canPublish = computed(
  () => hasDraft.value && !isAutosavePending.value && !isPublishing.value && !isLoading.value
)

const showDiscardModal = ref(false)
const showPublishModal = ref(false)
const isDiscarding = ref(false)
const isPublishing = ref(false)
const discardError = ref<string | null>(null)
const publishError = ref<string | null>(null)

const handleDiscardClick = () => {
  discardError.value = null
  showDiscardModal.value = true
}

const closeDiscardModal = () => {
  if (isDiscarding.value) return
  showDiscardModal.value = false
  discardError.value = null
}

const confirmDiscard = async () => {
  if (isDiscarding.value) return

  discardError.value = null
  isDiscarding.value = true
  try {
    await discardDraft()
    clearValidationState()
    resetForm()
    saveStatus.value = 'saved'
    dismissPublishNotice()
    showDiscardModal.value = false
  } catch (err: any) {
    discardError.value = err?.response?.data?.error ?? 'Failed to discard draft. Please try again.'
  } finally {
    isDiscarding.value = false
  }
}

const selectedIndustry = computed(() => {
  const industryValue = form.industry
  if (industryValue === '' || industryValue == null) return null

  const allIndustries = industries.value ?? []
  const asNumber = typeof industryValue === 'number' ? industryValue : Number(industryValue)

  if (!Number.isNaN(asNumber)) {
    const matchById = allIndustries.find((industry) => industry.id === asNumber)
    if (matchById) return matchById
  }

  if (typeof industryValue === 'string') {
    const normalized = industryValue.trim().toLowerCase()
    if (!normalized) return null
    const matchByName = allIndustries.find(
      (industry) => industry.name?.toLowerCase() === normalized
    )
    if (matchByName) return matchByName
  }

  return null
})

const resolvedIndustryName = computed(() => {
  if (selectedIndustry.value?.name) {
    return selectedIndustry.value.name
  }

  const industryValue = form.industry
  if (industryValue == null || industryValue === '') return ''

  if (typeof industryValue === 'number') {
    const matchById = industries.value.find((industry) => industry.id === industryValue)
    return matchById?.name ?? ''
  }

  if (typeof industryValue === 'string') {
    return industryValue.trim()
  }

  return ''
})

const normalizedIndustryForRules = computed(() => {
  const candidate = resolvedIndustryName.value.trim()
  if (candidate) return candidate.toLowerCase()

  const profileIndustry =
    typeof profile.value?.industry === 'string'
      ? profile.value.industry.trim().toLowerCase()
      : ''

  return profileIndustry
})

const industrySoftwareKey = computed(() => {
  const normalizedName = normalizedIndustryForRules.value
  if (normalizedName.includes('mining')) {
    return 'mining'
  }

  return 'default'
})

const shouldShowCommodities = computed(() => normalizedIndustryForRules.value.includes('mining'))

const shouldShowMiningOperations = computed(() => industryProfile.value?.sections.site_operations ?? false)

const shouldShowMarketData = computed(() => industryProfile.value?.sections.market_data ?? false)

const showKeyProjects = computed(() => industryProfile.value?.sections.key_projects ?? true)

const industryAttributeFieldErrors = computed(() =>
  Object.fromEntries(
    (industryProfile.value?.fields ?? [])
      .map((field) => [field.key, getFirstErrorForFields([`industry_attributes.${field.key}`])])
      .filter(([, message]) => message)
  ) as Record<string, string>
)

const handleIndustryAttributesUpdate = (value: CompanyIndustryAttributes) => {
  form.industry_attributes = value
  triggerAutosave()
}

const selectedCompanyIndustryOption = computed<CompanyIndustryOption | null>(() => {
  const normalized = resolvedIndustryName.value.trim().toLowerCase()
  if (!normalized) return null

  return companyIndustryOptions.value.find((option) => {
    const name = option.name.trim().toLowerCase()
    const slug = option.slug.trim().toLowerCase()
    return normalized === name || normalized === slug || normalized.includes(name) || name.includes(normalized)
  }) ?? null
})

const subcategoryOptions = computed<CompanyIndustrySubcategory[]>(() =>
  selectedCompanyIndustryOption.value?.subcategories ?? []
)

const softwareOptions = computed(() => {
  const key = industrySoftwareKey.value
  const options = SOFTWARE_LOOKUPS[key] ?? SOFTWARE_LOOKUPS.default
  return [...options]
})

const softwareSelection = computed<string[]>({
  get() {
    return Array.isArray(form.software_used) ? form.software_used : []
  },
  set(value) {
    form.software_used = value
    triggerAutosave()
  },
})

const syncIndustrySubcategory = () => {
  const selected = subcategoryOptions.value.find(
    (subcategory) => subcategory.id === Number(form.industry_subcategory_id)
  )

  if (!selected) {
    form.industry_subcategory_id = null
    form.industry_subcategory = ''
    return
  }

  form.industry_subcategory = selected.name
}

const handleIndustryChange = () => {
  syncIndustrySubcategory()
  triggerAutosave()
}

const handleSubcategoryChange = () => {
  syncIndustrySubcategory()
  triggerAutosave()
}

const hasCashInBankValue = computed(
  () => typeof form.cash_in_bank === 'string' && form.cash_in_bank.trim() !== ''
)

const cashRunwayError = computed(() => getFirstErrorForFields(['cash_runway']))

const tickerRef = toRef(form, 'ticker')
const marketCapRef = toRef(form, 'market_cap')
const showLogoUploader = ref(false)
const publishNotice = ref<PublishNoticeState | null>(null)

const sectionAnchors: Record<string, string> = {
  details: '#sec-details',
  profile: '#sec-profile',
  operations: '#sec-operations',
}

const JOB_LINK_FIELDS: Array<{
  type: JobLinkType
  label: string
  badge: string
  placeholder: string
  helpText: string
  title: string
  description: string
}> = [
  {
    type: 'linkedin',
    label: 'LinkedIn Jobs URL',
    badge: 'LinkedIn',
    placeholder: 'https://www.linkedin.com/company/your-company/jobs/',
    helpText: 'Use your company LinkedIn jobs page or a LinkedIn job search filtered to your company.',
    title: 'LinkedIn Jobs',
    description: 'Browse featured roles, team updates, and quick-apply opportunities on LinkedIn.',
  },
  {
    type: 'seek',
    label: 'SEEK Jobs URL',
    badge: 'SEEK',
    placeholder: 'https://www.seek.com.au/your-company-jobs',
    helpText: 'Link to your SEEK company listing or your SEEK job search results.',
    title: 'SEEK Listings',
    description: 'View advertised vacancies on SEEK, including site-based and corporate roles.',
  },
  {
    type: 'other',
    label: 'Other Careers URL',
    badge: 'Other',
    placeholder: 'https://yourcompany.com/careers',
    helpText: 'Use this for your own careers page or any other external hiring destination.',
    title: 'Company Careers Page',
    description: 'Visit the company’s own careers hub for direct applications and employer branding.',
  },
]

const SOCIAL_LINK_FIELDS: Array<{
  type: SocialLinkType
  label: string
  placeholder: string
  helpText: string
}> = [
  {
    type: 'linkedin',
    label: 'LinkedIn',
    placeholder: 'https://www.linkedin.com/company/your-company',
    helpText: 'Use your main company LinkedIn page.',
  },
  {
    type: 'x',
    label: 'X',
    placeholder: 'https://x.com/yourcompany',
    helpText: 'Add your X profile if you actively share company updates there.',
  },
  {
    type: 'facebook',
    label: 'Facebook',
    placeholder: 'https://www.facebook.com/yourcompany',
    helpText: 'Use your public company Facebook page.',
  },
  {
    type: 'instagram',
    label: 'Instagram',
    placeholder: 'https://www.instagram.com/yourcompany',
    helpText: 'Use your Instagram profile if it reflects your employer brand.',
  },
  {
    type: 'youtube',
    label: 'YouTube',
    placeholder: 'https://www.youtube.com/@yourcompany',
    helpText: 'Link to your company YouTube channel for project, team, or brand content.',
  },
]

const pluralize = (count: number, singular: string, plural?: string) => {
  const resolvedPlural = plural ?? `${singular}s`
  return count === 1 ? singular : resolvedPlural
}

const buildPublishNotice = (): PublishNoticeState => {
  const sections = checklistSections.value ?? []
  const issues = sections.flatMap((section) =>
    section.items
      .filter((item) => !item.complete && (item.required || item.message))
      .map((item) => ({
        id: `${section.id}-${item.id}`,
        label: item.label,
        sectionLabel: section.label,
        required: item.required,
        anchor: sectionAnchors[section.id],
      }))
  )

  const requiredIssues = issues.filter((issue) => issue.required)
  const focusGroup = requiredIssues.length ? requiredIssues : issues
  const totalRequired = requiredIssues.length
  const totalIssues = issues.length

  const headline = !issues.length
    ? 'Review your profile before publishing'
    : totalRequired
      ? 'A few essentials still need your input'
      : 'Almost there—polish the final details'

  const messageParts = [
    !issues.length
      ? 'Update the checklist items highlighted in red on the left to continue.'
      : totalRequired
        ? `We noticed ${totalRequired} required ${pluralize(totalRequired, 'section')} that still need a quick update.`
        : `We noticed ${totalIssues} ${pluralize(totalIssues, 'detail')} that still need a quick update.`,
    'Everything flagged in red on the checklist will guide you step by step.',
  ]

  const chips = focusGroup.slice(0, 3).map((issue) => ({
    id: issue.id,
    label: `${issue.sectionLabel} · ${issue.label}`,
    anchor: issue.anchor,
  }))

  return {
    headline,
    message: messageParts.join(' '),
    chips,
    primaryAnchor: focusGroup[0]?.anchor,
  }
}

const scrollToAnchor = (anchor?: string) => {
  if (!anchor || typeof window === 'undefined') return
  const target = document.querySelector(anchor)
  if (target instanceof HTMLElement) {
    target.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
}

let publishNoticeTimer: ReturnType<typeof setTimeout> | null = null
const showPublishNotice = () => {
  publishNotice.value = buildPublishNotice()
  if (publishNoticeTimer) {
    clearTimeout(publishNoticeTimer)
  }
  publishNoticeTimer = setTimeout(() => {
    publishNotice.value = null
  }, SHOW_NOTICE_DURATION)
}

const dismissPublishNotice = () => {
  if (publishNoticeTimer) {
    clearTimeout(publishNoticeTimer)
    publishNoticeTimer = null
  }
  publishNotice.value = null
}

const handleReviewIssues = () => {
  scrollToAnchor(publishNotice.value?.primaryAnchor)
  dismissPublishNotice()
}

const handleChipClick = (chip: PublishNoticeChip) => {
  scrollToAnchor(chip.anchor)
  dismissPublishNotice()
}

const {
  isFetching: isFetchingMarketCap,
  error: marketCapError,
  onTickerInput: handleTickerInputInner,
} = useCompanyMarketData(tickerRef, marketCapRef, {
  fetcher: async (symbol) => {
    try {
      const { data } = await getCompanyMarketData(symbol)
      return data
    } catch (err: any) {
      if (err?.response?.status === 404) {
        return { notFound: true }
      }
      throw err
    }
  },
  onResult: (_result, meta) => {
    if (meta.fromUser) {
      triggerAutosave()
    }
  },
})

const handleTickerInput = (event: Event) => {
  if (form.is_private_company) return
  handleTickerInputInner(event)
  triggerAutosave()
}

const normalizeAmountDisplay = (value: unknown): string => {
  const digits = String(value ?? '').replace(/[^\d]/g, '')
  if (!digits) return ''

  return new Intl.NumberFormat('en-AU').format(Number(digits))
}

const normalizeDecimalInput = (value: unknown): string => {
  const raw = String(value ?? '').replace(/[^\d.]/g, '')
  const [whole = '', ...decimalParts] = raw.split('.')
  if (decimalParts.length === 0) return whole
  return `${whole}.${decimalParts.join('')}`
}

const handlePrivateToggle = () => {
  if (form.is_private_company) {
    form.ticker = ''
    form.market_cap = ''
  }
  triggerAutosave()
}

const handleCashInBankInput = () => {
  form.cash_in_bank = normalizeAmountDisplay(form.cash_in_bank)
  form.cash_in_bank_updated_at = null
  triggerAutosave()
}

const handleCashRunwayInput = () => {
  form.cash_runway = normalizeDecimalInput(form.cash_runway)
  triggerAutosave()
}

const handleCapitalRaisingAmountInput = (index: number) => {
  if (!form.recent_capital_raisings) return
  const raising = form.recent_capital_raisings[index]
  if (!raising) return

  raising.amount = normalizeAmountDisplay(raising.amount)
  triggerAutosave()
}

const handleLogoUploaded = ({ url, fileType }: { url: string; fileType: string }) => {
  form.logo = url
  form.logo_type = fileType
  triggerAutosave()
  showLogoUploader.value = false
}

const handleLogoRemoved = () => {
  form.logo = ''
  form.logo_type = null
  triggerAutosave()
}

const closePublishModal = () => {
  if (isPublishing.value) return
  showPublishModal.value = false
  publishError.value = null
}

const handlePublish = () => {
  const result = validateForPublish()
  if (!result.success) {
    showPublishNotice()
    return
  }

  publishError.value = null
  showPublishModal.value = true
}

const confirmPublish = async () => {
  if (isPublishing.value) return

  publishError.value = null
  isPublishing.value = true

  try {
    const payload = preparePublishPayload()
    await publishProfile(payload)
    clearValidationState()
    resetForm()
    saveStatus.value = 'saved'
    dismissPublishNotice()
    showPublishModal.value = false
  } catch (err: any) {
    if (err instanceof Error && err.message === 'Validation failed') {
      showPublishNotice()
      publishError.value = 'Please resolve the highlighted fields before publishing.'
    } else {
      publishError.value = err?.response?.data?.error ?? 'Failed to publish profile. Please try again.'
    }
  } finally {
    isPublishing.value = false
  }
}

const toggleCommodity = (commodity: string) => {
  if (!form.commodities) form.commodities = []

  if (form.commodities.includes(commodity)) {
    form.commodities = form.commodities.filter((c) => c !== commodity)
  } else {
    form.commodities.push(commodity)
  }

  triggerAutosave()
}

const getJobLinkUrl = (type: JobLinkType): string => {
  if (!Array.isArray(form.job_links)) return ''
  return form.job_links.find((jobLink) => jobLink.type === type)?.url ?? ''
}

const getSocialLinkUrl = (type: SocialLinkType): string => {
  if (!Array.isArray(form.social_links)) return ''
  return form.social_links.find((socialLink) => socialLink.type === type)?.url ?? ''
}

const handleJobLinkInput = (type: JobLinkType, event: Event) => {
  const target = event.target
  const value = target instanceof HTMLInputElement ? target.value : ''
  updateJobLinkUrl(type, value)
}

const updateJobLinkUrl = (type: JobLinkType, rawValue: string) => {
  if (!Array.isArray(form.job_links)) {
    form.job_links = []
  }

  const value = rawValue.trim()
  const fieldConfig = JOB_LINK_FIELDS.find((field) => field.type === type)
  if (!fieldConfig) return

  const existingIndex = form.job_links.findIndex((jobLink) => jobLink.type === type)

  if (value === '') {
    if (existingIndex !== -1) {
      form.job_links.splice(existingIndex, 1)
    }
    triggerAutosave()
    return
  }

  const nextEntry = {
    type,
    title: fieldConfig.title,
    description: fieldConfig.description,
    url: value,
  }

  if (existingIndex === -1) {
    form.job_links.push(nextEntry)
  } else {
    form.job_links[existingIndex] = nextEntry
  }

  triggerAutosave()
}

const handleSocialLinkInput = (type: SocialLinkType, event: Event) => {
  const target = event.target
  const value = target instanceof HTMLInputElement ? target.value : ''
  updateSocialLinkUrl(type, value)
}

const updateSocialLinkUrl = (type: SocialLinkType, rawValue: string) => {
  if (!Array.isArray(form.social_links)) {
    form.social_links = []
  }

  const value = rawValue.trim()
  const existingIndex = form.social_links.findIndex((socialLink) => socialLink.type === type)

  if (value === '') {
    if (existingIndex !== -1) {
      form.social_links.splice(existingIndex, 1)
    }
    triggerAutosave()
    return
  }

  const nextEntry = {
    type,
    url: value,
  }

  if (existingIndex === -1) {
    form.social_links.push(nextEntry)
  } else {
    form.social_links[existingIndex] = nextEntry
  }

  triggerAutosave()
}

const addPerson = () => {
  if (!form.key_people) form.key_people = []
  form.key_people.push({ first_name: '', last_name: '', role: '', role_start_date: '' })
  triggerAutosave()
}

const removePerson = (index: number) => {
  if (!form.key_people) return
  form.key_people.splice(index, 1)
  triggerAutosave()
}

const addProject = () => {
  if (!form.key_projects) form.key_projects = []
  form.key_projects.push({
    name: '',
    stage: '',
    description: '',
    location_label: '',
    location_lat: null,
    location_lng: null,
    commodities: [],
    activity_feed: [],
  })
  triggerAutosave()
}

const removeProject = (index: number) => {
  if (!form.key_projects) return
  form.key_projects.splice(index, 1)
  triggerAutosave()
}

const addRecentKeyHire = () => {
  if (!form.recent_key_hires) form.recent_key_hires = []
  form.recent_key_hires.push({
    name: '',
    role: '',
    date: '',
    background: 'Appointment',
    summary: '',
    url: '',
  })
  triggerAutosave()
}

const removeRecentKeyHire = (index: number) => {
  if (!form.recent_key_hires) return
  form.recent_key_hires.splice(index, 1)
  triggerAutosave()
}

const addCapitalRaising = () => {
  if (!form.recent_capital_raisings) form.recent_capital_raisings = []
  form.recent_capital_raisings.push({
    date: '',
    amount: '',
    label: '',
    summary: '',
    url: '',
  })
  triggerAutosave()
}

const removeCapitalRaising = (index: number) => {
  if (!form.recent_capital_raisings) return
  form.recent_capital_raisings.splice(index, 1)
  triggerAutosave()
}

const addBenefit = () => {
  if (!form.benefits) form.benefits = []

  const now = new Date()
  const localDate = new Date(now.getTime() - now.getTimezoneOffset() * 60000)

  form.benefits.push({
    heading: '',
    description: '',
    source: '',
    added_at: localDate.toISOString().slice(0, 10),
  })
  triggerAutosave()
}

const removeBenefit = (index: number) => {
  if (!form.benefits) return
  form.benefits.splice(index, 1)
  triggerAutosave()
}

const toggleProjectCommodity = (index: number, commodity: string) => {
  if (!form.key_projects) return
  const project = form.key_projects[index]
  if (!project) return
  if (!Array.isArray(project.commodities)) {
    project.commodities = []
  }
  if (project.commodities.includes(commodity)) {
    project.commodities = project.commodities.filter((item) => item !== commodity)
  } else {
    project.commodities.push(commodity)
  }
  triggerAutosave()
}

const addProjectActivity = (index: number) => {
  if (!form.key_projects) return
  const project = form.key_projects[index]
  if (!project) return
  if (!Array.isArray(project.activity_feed)) {
    project.activity_feed = []
  }
  project.activity_feed.push({ date: '', text: '' })
  triggerAutosave()
}

const removeProjectActivity = (projectIndex: number, activityIndex: number) => {
  if (!form.key_projects) return
  const project = form.key_projects[projectIndex]
  if (!project || !Array.isArray(project.activity_feed)) return
  project.activity_feed.splice(activityIndex, 1)
  triggerAutosave()
}

const updateProjectLocation = (index: number, location: { lat: number; lng: number }) => {
  if (!form.key_projects) return
  const project = form.key_projects[index]
  if (!project) return
  project.location_lat = location.lat
  project.location_lng = location.lng
  triggerAutosave()
}

onMounted(() => {
  loadProfile()
  industryStore.fetchIndustries()
  industryProfileStore.fetchProfiles()
  getCompanyIndustryOptions()
    .then(({ data }) => {
      companyIndustryOptions.value = Array.isArray(data?.data) ? data.data : []
    })
    .catch((err) => {
      console.error('Failed to fetch company industry options', err)
    })
});

onBeforeUnmount(() => {
  if (publishNoticeTimer) {
    clearTimeout(publishNoticeTimer)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _cache[54] || (_cache[54] = _createElementVNode("h1", { class: "text-base font-semibold leading-tight" }, "Company Profile Editor", -1)),
            _createElementVNode("p", _hoisted_5, _toDisplayString(statusLabel.value), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (hasDraft.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "px-3 py-2 text-sm rounded-md border border-border hover:bg-muted disabled:opacity-60 disabled:cursor-not-allowed",
                onClick: handleDiscardClick,
                disabled: isDiscarding.value || isPublishing.value || _unref(isLoading) || isAutosavePending.value
              }, [
                (!isDiscarding.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Discard Draft"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_9, [
                      _createVNode(_unref(Loader2), { class: "h-4 w-4 animate-spin" }),
                      _cache[55] || (_cache[55] = _createTextVNode(" Discarding… "))
                    ]))
              ], 8, _hoisted_7))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "px-3 py-2 text-sm rounded-md bg-brand text-white hover:opacity-90 disabled:opacity-60 disabled:cursor-not-allowed",
            onClick: handlePublish,
            disabled: !canPublish.value
          }, [
            (!isPublishing.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Publish"))
              : (_openBlock(), _createElementBlock("span", _hoisted_12, [
                  _createVNode(_unref(Loader2), { class: "h-4 w-4 animate-spin" }),
                  _cache[56] || (_cache[56] = _createTextVNode(" Publishing… "))
                ]))
          ], 8, _hoisted_10)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      (_unref(isChecklistReady))
        ? (_openBlock(), _createElementBlock("nav", _hoisted_14, [
            _createElementVNode("section", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _cache[57] || (_cache[57] = _createElementVNode("h2", {
                  id: "nav-completion",
                  class: "text-sm font-semibold"
                }, "Profile completeness", -1)),
                _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(isChecklistReady) ? `${_unref(checklistProgress)}%` : '…'), 1)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", {
                  class: "h-full bg-newPrimary transition-all duration-300",
                  style: _normalizeStyle({ width: _unref(isChecklistReady) ? `${_unref(checklistProgress)}%` : '0%' })
                }, null, 4)
              ]),
              (_unref(isChecklistReady))
                ? (_openBlock(), _createElementBlock("ul", _hoisted_19, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(checklistSections), (section) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: section.id,
                        class: "flex flex-col gap-1"
                      }, [
                        _createElementVNode("div", _hoisted_20, [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(section.complete ? _unref(CheckCircle2) : _unref(Circle)), {
                            class: _normalizeClass(["h-4 w-4", section.complete ? 'text-brand' : 'text-muted-foreground'])
                          }, null, 8, ["class"])),
                          _createElementVNode("span", {
                            class: _normalizeClass(["text-sm font-medium", section.complete ? 'text-foreground' : 'text-muted-foreground'])
                          }, _toDisplayString(section.label), 3)
                        ]),
                        (!section.complete)
                          ? (_openBlock(), _createElementBlock("ul", _hoisted_21, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.items.filter((item) => !item.complete), (item) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: item.id,
                                  class: "flex items-start gap-3 text-muted-foreground"
                                }, [
                                  (_openBlock(), _createBlock(_resolveDynamicComponent(item.required ? _unref(AlertCircle) : _unref(Circle)), {
                                    class: _normalizeClass(["h-4 w-4 flex-shrink-0 mt-[1px]", item.required
                      ? 'text-red-500'
                      : _unref(isPublishAttempted) && item.message
                        ? 'text-red-500'
                        : 'text-muted-foreground'])
                                  }, null, 8, ["class"])),
                                  _createElementVNode("div", _hoisted_22, [
                                    _createElementVNode("span", _hoisted_23, _toDisplayString(item.label), 1),
                                    (_unref(isPublishAttempted) && item.message)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(item.message), 1))
                                      : (item.description)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(item.description), 1))
                                        : _createCommentVNode("", true)
                                  ])
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : (_unref(industryProfileStore).error)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(_unref(industryProfileStore).error), 1))
                  : (_openBlock(), _createElementBlock("p", _hoisted_27, "Loading checklist…"))
            ]),
            _cache[58] || (_cache[58] = _createStaticVNode("<section class=\"rounded-lg border border-border bg-card p-2\" data-v-56c31c1d><ul class=\"space-y-1\" data-v-56c31c1d><li data-v-56c31c1d><a href=\"#sec-details\" class=\"block rounded-md px-3 py-2 text-sm hover:bg-muted aria-[current=page]:bg-muted\" aria-current=\"page\" data-v-56c31c1d>Company Details</a></li><li data-v-56c31c1d><a href=\"#sec-profile\" class=\"block rounded-md px-3 py-2 text-sm hover:bg-muted\" data-v-56c31c1d>Company Profile</a></li><li data-v-56c31c1d><a href=\"#sec-operations\" class=\"block rounded-md px-3 py-2 text-sm hover:bg-muted\" data-v-56c31c1d>Operations Overview</a></li></ul></section>", 1))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_28, _cache[59] || (_cache[59] = [
            _createStaticVNode("<section class=\"rounded-lg border border-border bg-card p-4\" data-v-56c31c1d><div class=\"h-4 w-32 rounded bg-muted\" data-v-56c31c1d></div><div class=\"mt-4 space-y-3\" data-v-56c31c1d><div class=\"h-3 w-full rounded bg-muted\" data-v-56c31c1d></div><div class=\"h-3 w-3/4 rounded bg-muted\" data-v-56c31c1d></div><div class=\"h-3 w-2/4 rounded bg-muted\" data-v-56c31c1d></div></div></section><section class=\"rounded-lg border border-border bg-card p-4\" data-v-56c31c1d><div class=\"h-3 w-1/2 rounded bg-muted\" data-v-56c31c1d></div><div class=\"mt-3 space-y-2\" data-v-56c31c1d><div class=\"h-2.5 w-full rounded bg-muted\" data-v-56c31c1d></div><div class=\"h-2.5 w-5/6 rounded bg-muted\" data-v-56c31c1d></div><div class=\"h-2.5 w-4/6 rounded bg-muted\" data-v-56c31c1d></div></div></section>", 2)
          ]))),
      (_unref(isChecklistReady))
        ? (_openBlock(), _createElementBlock("main", _hoisted_29, [
            _createElementVNode("section", _hoisted_30, [
              _cache[75] || (_cache[75] = _createElementVNode("h2", { class: "text-lg font-semibold mb-6" }, "Company Details", -1)),
              _createElementVNode("div", {
                class: _normalizeClass([
            'flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4',
            showLogoUploader.value ? 'mb-4' : 'mb-8'
          ])
              }, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    (_unref(form).logo)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _unref(form).logo,
                          alt: "Company Logo",
                          class: "max-h-full max-w-full object-contain"
                        }, null, 8, _hoisted_33))
                      : (_openBlock(), _createElementBlock("span", _hoisted_34, "Logo"))
                  ]),
                  _cache[60] || (_cache[60] = _createElementVNode("div", null, [
                    _createElementVNode("h3", { class: "text-sm font-medium text-foreground" }, "Company Logo"),
                    _createElementVNode("p", { class: "text-xs text-muted-foreground" }, " PNG, JPG or SVG up to 2 MB · Recommended ≥ 400×400 px ")
                  ], -1))
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "inline-flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium bg-brand text-white hover:opacity-90 transition shadow-sm",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (showLogoUploader.value = true))
                }, _cache[61] || (_cache[61] = [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    class: "h-4 w-4",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M12 4v16m8-8H4"
                    })
                  ], -1),
                  _createTextVNode(" Replace Logo ")
                ]))
              ], 2),
              (showLogoUploader.value)
                ? (_openBlock(), _createBlock(ProfileLogoUploader, {
                    key: 0,
                    class: "mt-2 mb-8",
                    "current-logo": _unref(form).logo,
                    onUploaded: handleLogoUploaded,
                    onRemoved: handleLogoRemoved,
                    onClose: _cache[1] || (_cache[1] = ($event: any) => (showLogoUploader.value = false))
                  }, null, 8, ["current-logo"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("label", _hoisted_36, [
                  _cache[62] || (_cache[62] = _createElementVNode("span", { class: "text-sm font-medium" }, "Company Name", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).name) = $event)),
                    onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(triggerAutosave) && _unref(triggerAutosave)(...args))),
                    class: "mt-1 w-full rounded-md border border-border bg-background px-3 py-2 text-sm focus:ring-1 focus:ring-brand outline-none",
                    placeholder: "Acme Mining Corp"
                  }, null, 544), [
                    [_vModelText, _unref(form).name]
                  ])
                ]),
                _createElementVNode("label", _hoisted_37, [
                  _cache[64] || (_cache[64] = _createElementVNode("span", { class: "text-sm font-medium" }, "Industry", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).industry) = $event)),
                    disabled: _unref(isLoadingIndustries),
                    onChange: handleIndustryChange,
                    class: "mt-1 w-full rounded-md border border-border bg-background px-3 py-2 text-sm focus:ring-1 focus:ring-brand outline-none"
                  }, [
                    _cache[63] || (_cache[63] = _createElementVNode("option", { value: "" }, "Select industry", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(industries), (industry) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: industry.id,
                        value: industry.id
                      }, _toDisplayString(industry.name), 9, _hoisted_39))
                    }), 128))
                  ], 40, _hoisted_38), [
                    [_vModelSelect, _unref(form).industry]
                  ])
                ]),
                (subcategoryOptions.value.length)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_40, [
                      _cache[66] || (_cache[66] = _createElementVNode("span", { class: "text-sm font-medium" }, [
                        _createTextVNode("Subcategory "),
                        _createElementVNode("span", { class: "text-muted-foreground" }, "(optional)")
                      ], -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).industry_subcategory_id) = $event)),
                        onChange: handleSubcategoryChange,
                        class: "mt-1 w-full rounded-md border border-border bg-background px-3 py-2 text-sm focus:ring-1 focus:ring-brand outline-none"
                      }, [
                        _cache[65] || (_cache[65] = _createElementVNode("option", { value: null }, "Select subcategory", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subcategoryOptions.value, (subcategory) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: subcategory.id,
                            value: subcategory.id
                          }, _toDisplayString(subcategory.name), 9, _hoisted_41))
                        }), 128))
                      ], 544), [
                        [
                          _vModelSelect,
                          _unref(form).industry_subcategory_id,
                          void 0,
                          { number: true }
                        ]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("label", _hoisted_42, [
                  _cache[68] || (_cache[68] = _createElementVNode("span", { class: "text-sm font-medium" }, "Employee Size", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).employee_size) = $event)),
                    onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_unref(triggerAutosave) && _unref(triggerAutosave)(...args))),
                    class: "mt-1 w-full rounded-md border border-border bg-background px-3 py-2 text-sm focus:ring-1 focus:ring-brand outline-none"
                  }, [
                    _cache[67] || (_cache[67] = _createElementVNode("option", { value: "" }, "Select size", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(EMPLOYEE_SIZES), (size) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: size,
                        value: size
                      }, _toDisplayString(size), 9, _hoisted_43))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _unref(form).employee_size]
                  ])
                ]),
                _createElementVNode("label", _hoisted_44, [
                  _cache[69] || (_cache[69] = _createElementVNode("span", { class: "text-sm font-medium" }, [
                    _createTextVNode("Headcount Growth (Last 12 Months) "),
                    _createElementVNode("span", { class: "text-muted-foreground" }, "(%)")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(form).headcount_growth_12_months) = $event)),
                    onInput: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_unref(triggerAutosave) && _unref(triggerAutosave)(...args))),
                    class: "mt-1 w-full rounded-md border border-border bg-background px-3 py-2 text-sm focus:ring-1 focus:ring-brand outline-none",
                    placeholder: "e.g., 12"
                  }, null, 544), [
                    [_vModelText, _unref(form).headcount_growth_12_months]
                  ])
                ]),
                _createElementVNode("label", _hoisted_45, [
                  _cache[70] || (_cache[70] = _createElementVNode("span", { class: "text-sm font-medium" }, [
                    _createTextVNode("Average Employee Tenure "),
                    _createElementVNode("span", { class: "text-muted-foreground" }, "(years)")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(form).average_employee_tenure) = $event)),
                    onInput: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_unref(triggerAutosave) && _unref(triggerAutosave)(...args))),
                    class: "mt-1 w-full rounded-md border border-border bg-background px-3 py-2 text-sm focus:ring-1 focus:ring-brand outline-none",
                    placeholder: "e.g., 3.5"
                  }, null, 544), [
                    [_vModelText, _unref(form).average_employee_tenure]
                  ])
                ]),
                _createElementVNode("label", _hoisted_46, [
                  _cache[71] || (_cache[71] = _createElementVNode("span", { class: "text-sm font-medium" }, "Website", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(form).website) = $event)),
                    onInput: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_unref(triggerAutosave) && _unref(triggerAutosave)(...args))),
                    class: "mt-1 w-full rounded-md border border-border bg-background px-3 py-2 text-sm focus:ring-1 focus:ring-brand outline-none",
                    placeholder: "https://example.com"
                  }, null, 544), [
                    [_vModelText, _unref(form).website]
                  ])
                ]),
                _createElementVNode("label", _hoisted_47, [
                  _cache[72] || (_cache[72] = _createElementVNode("span", { class: "text-sm font-medium" }, "Head Office", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(form).office_address) = $event)),
                    onInput: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_unref(triggerAutosave) && _unref(triggerAutosave)(...args))),
                    class: "mt-1 w-full rounded-md border border-border bg-background px-3 py-2 text-sm focus:ring-1 focus:ring-brand outline-none",
                    placeholder: "Perth, WA"
                  }, null, 544), [
                    [_vModelText, _unref(form).office_address]
                  ])
                ]),
                _createElementVNode("label", _hoisted_48, [
                  _cache[73] || (_cache[73] = _createElementVNode("span", { class: "text-sm font-medium" }, [
                    _createTextVNode("Company email "),
                    _createElementVNode("span", { class: "text-muted-foreground" }, "(optional)")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(form).contact_email) = $event)),
                    onInput: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_unref(triggerAutosave) && _unref(triggerAutosave)(...args))),
                    type: "email",
                    class: "mt-1 w-full rounded-md border border-border bg-background px-3 py-2 text-sm focus:ring-1 focus:ring-brand outline-none",
                    placeholder: "contact@example.com"
                  }, null, 544), [
                    [_vModelText, _unref(form).contact_email]
                  ])
                ]),
                _createElementVNode("label", _hoisted_49, [
                  _cache[74] || (_cache[74] = _createElementVNode("span", { class: "text-sm font-medium" }, "Company Summary", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(form).summary) = $event)),
                    onInput: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_unref(triggerAutosave) && _unref(triggerAutosave)(...args))),
                    class: "mt-1 w-full min-h-[96px] rounded-md border border-border bg-background px-3 py-2 text-sm focus:ring-1 focus:ring-brand outline-none resize-none",
                    placeholder: "Describe your mission, operations, and key activities..."
                  }, null, 544), [
                    [_vModelText, _unref(form).summary]
                  ])
                ])
              ])
            ]),
            _createElementVNode("section", _hoisted_50, [
              _cache[114] || (_cache[114] = _createElementVNode("h2", { class: "text-lg font-semibold mb-6" }, "Company Profile", -1)),
              _createElementVNode("div", _hoisted_51, [
                _cache[77] || (_cache[77] = _createElementVNode("div", { class: "flex items-center gap-2 mb-2" }, [
                  _createElementVNode("label", { class: "font-medium text-sm" }, "Key People"),
                  _createElementVNode("span", { class: "text-muted-foreground text-xs" }, "(executives, managers, etc.)")
                ], -1)),
                _createElementVNode("div", _hoisted_52, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(form).key_people, (person, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "rounded-lg border border-border/60 bg-background/70 p-3 shadow-sm"
                    }, [
                      _createElementVNode("div", _hoisted_53, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((person.first_name) = $event),
                          onInput: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_unref(triggerAutosave) && _unref(triggerAutosave)(...args))),
                          type: "text",
                          placeholder: "First name",
                          class: "border border-border rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-brand focus:border-transparent outline-none"
                        }, null, 40, _hoisted_54), [
                          [_vModelText, person.first_name]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((person.last_name) = $event),
                          onInput: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_unref(triggerAutosave) && _unref(triggerAutosave)(...args))),
                          type: "text",
                          placeholder: "Last name",
                          class: "border border-border rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-brand focus:border-transparent outline-none"
                        }, null, 40, _hoisted_55), [
                          [_vModelText, person.last_name]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((person.role) = $event),
                          onInput: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_unref(triggerAutosave) && _unref(triggerAutosave)(...args))),
                          type: "text",
                          placeholder: "Role / Job Title",
                          class: "border border-border rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-brand focus:border-transparent outline-none sm:col-span-1"
                        }, null, 40, _hoisted_56), [
                          [_vModelText, person.role]
                        ]),
                        _createVNode(_unref(VueDatePicker), {
                          modelValue: person.role_start_date,
                          "onUpdate:modelValue": [($event: any) => ((person.role_start_date) = $event), _unref(triggerAutosave)],
                          "enable-time-picker": false,
                          "auto-apply": "",
                          teleport: "",
                          "model-type": "yyyy-MM-dd",
                          format: "dd/MM/yyyy",
                          placeholder: "Role start date",
                          "input-class": [
                    'w-full h-10 rounded-md border border-border text-foreground px-3 text-sm focus:ring-2 focus:ring-brand focus:border-brand bg-background',
                  ],
                          "menu-class": ['rounded-lg shadow-lg border border-border bg-background']
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      (_unref(form).key_people && _unref(form).key_people.length > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                            _createElementVNode("button", {
                              onClick: ($event: any) => (removePerson(index)),
                              class: "inline-flex items-center gap-1 rounded-md border border-border px-2.5 py-1 text-xs font-medium text-muted-foreground transition hover:border-brand hover:text-foreground",
                              type: "button"
                            }, _cache[76] || (_cache[76] = [
                              _createElementVNode("span", null, "Remove", -1)
                            ]), 8, _hoisted_58)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128)),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: addPerson,
                    class: "w-full border border-dashed rounded-md py-2 text-sm text-muted-foreground hover:border-brand hover:text-foreground transition-colors"
                  }, " + Add Person ")
                ])
              ]),
              _createElementVNode("div", _hoisted_59, [
                _cache[80] || (_cache[80] = _createElementVNode("div", { class: "flex items-center gap-2 mb-2" }, [
                  _createElementVNode("label", { class: "font-medium text-sm" }, "Executive Movements"),
                  _createElementVNode("span", { class: "text-muted-foreground text-xs" }, "(optional)")
                ], -1)),
                _cache[81] || (_cache[81] = _createElementVNode("p", { class: "mb-4 text-sm text-muted-foreground" }, " Highlight notable recent leadership appointments or resignations with a short summary and source link. ", -1)),
                _createElementVNode("div", _hoisted_60, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(form).recent_key_hires, (hire, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "rounded-lg border border-border/60 bg-background/80 p-4 shadow-sm space-y-3"
                    }, [
                      _createElementVNode("div", _hoisted_61, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((hire.name) = $event),
                          onInput: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_unref(triggerAutosave) && _unref(triggerAutosave)(...args))),
                          type: "text",
                          placeholder: "Full name",
                          class: "border border-border rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-brand focus:border-transparent outline-none"
                        }, null, 40, _hoisted_62), [
                          [_vModelText, hire.name]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((hire.role) = $event),
                          onInput: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_unref(triggerAutosave) && _unref(triggerAutosave)(...args))),
                          type: "text",
                          placeholder: "Role / Title",
                          class: "border border-border rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-brand focus:border-transparent outline-none"
                        }, null, 40, _hoisted_63), [
                          [_vModelText, hire.role]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((hire.date) = $event),
                          onInput: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_unref(triggerAutosave) && _unref(triggerAutosave)(...args))),
                          type: "date",
                          class: "border border-border rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-brand focus:border-transparent outline-none"
                        }, null, 40, _hoisted_64), [
                          [_vModelText, hire.date]
                        ]),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": ($event: any) => ((hire.background) = $event),
                          onChange: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_unref(triggerAutosave) && _unref(triggerAutosave)(...args))),
                          class: "border border-border rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-brand focus:border-transparent outline-none"
                        }, _cache[78] || (_cache[78] = [
                          _createElementVNode("option", { value: "Appointment" }, "Appointment", -1),
                          _createElementVNode("option", { value: "Resignation" }, "Resignation", -1)
                        ]), 40, _hoisted_65), [
                          [_vModelSelect, hire.background]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((hire.url) = $event),
                          onInput: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_unref(triggerAutosave) && _unref(triggerAutosave)(...args))),
                          type: "url",
                          placeholder: "Source URL",
                          class: "border border-border rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-brand focus:border-transparent outline-none md:col-span-2"
                        }, null, 40, _hoisted_66), [
                          [_vModelText, hire.url]
                        ]),
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": ($event: any) => ((hire.summary) = $event),
                          onInput: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_unref(triggerAutosave) && _unref(triggerAutosave)(...args))),
                          rows: "3",
                          placeholder: "Short summary",
                          class: "border border-border rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-brand focus:border-transparent outline-none resize-none md:col-span-2"
                        }, null, 40, _hoisted_67), [
                          [_vModelText, hire.summary]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_68, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (removeRecentKeyHire(index)),
                          class: "inline-flex items-center gap-1 rounded-md border border-border px-2.5 py-1 text-xs font-medium text-muted-foreground transition hover:border-brand hover:text-foreground",
                          type: "button"
                        }, _cache[79] || (_cache[79] = [
                          _createElementVNode("span", null, "Remove", -1)
                        ]), 8, _hoisted_69)
                      ])
                    ]))
                  }), 128)),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: addRecentKeyHire,
                    class: "w-full border border-dashed rounded-md py-2 text-sm text-muted-foreground hover:border-brand hover:text-foreground transition-colors"
                  }, " + Add Executive Movement ")
                ])
              ]),
              (false && shouldShowCommodities.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                    _cache[82] || (_cache[82] = _createElementVNode("h3", { class: "text-sm font-medium mb-2" }, "Commodities", -1)),
                    _createElementVNode("div", _hoisted_71, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(COMMODITIES), (commodity) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: commodity,
                          type: "button",
                          onClick: ($event: any) => (toggleCommodity(commodity)),
                          class: _normalizeClass(["rounded-full border px-3 py-1 text-xs transition-colors", _unref(form).commodities?.includes(commodity)
                ? 'bg-brand text-white border-brand'
                : 'border-border text-muted-foreground hover:border-brand hover:text-foreground'])
                        }, _toDisplayString(commodity), 11, _hoisted_72))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_unref(industryProfile)?.fields.length)
                ? (_openBlock(), _createBlock(IndustryAttributeFields, {
                    key: 1,
                    class: "mb-8",
                    profile: _unref(industryProfile),
                    "model-value": _unref(form).industry_attributes,
                    errors: industryAttributeFieldErrors.value,
                    "onUpdate:modelValue": handleIndustryAttributesUpdate
                  }, null, 8, ["profile", "model-value", "errors"]))
                : _createCommentVNode("", true),
              (showKeyProjects.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                    _cache[86] || (_cache[86] = _createElementVNode("div", { class: "flex items-center gap-2 mb-2" }, [
                      _createElementVNode("label", { class: "font-medium text-sm" }, "Key Projects"),
                      _createElementVNode("span", { class: "text-muted-foreground text-xs" }, "(optional)")
                    ], -1)),
                    _createElementVNode("div", _hoisted_74, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(form).key_projects, (project, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "rounded-lg border border-border/60 bg-background/80 p-3 shadow-sm space-y-2"
                        }, [
                          _createElementVNode("div", _hoisted_75, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((project.name) = $event),
                              type: "text",
                              placeholder: "Project Name",
                              onInput: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_unref(triggerAutosave) && _unref(triggerAutosave)(...args))),
                              class: "flex-1 border border-border rounded-md px-3 py-2 focus:ring-2 focus:ring-brand focus:border-transparent outline-none text-sm"
                            }, null, 40, _hoisted_76), [
                              [_vModelText, project.name]
                            ]),
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": ($event: any) => ((project.stage) = $event),
                              onChange: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_unref(triggerAutosave) && _unref(triggerAutosave)(...args))),
                              class: "flex-1 border border-border rounded-md px-3 py-2 focus:ring-2 focus:ring-brand focus:border-transparent outline-none text-sm"
                            }, [
                              _cache[83] || (_cache[83] = _createElementVNode("option", { value: "" }, "Select Stage", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PROJECT_STAGES), (stage) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: stage,
                                  value: stage
                                }, _toDisplayString(stage), 9, _hoisted_78))
                              }), 128))
                            ], 40, _hoisted_77), [
                              [_vModelSelect, project.stage]
                            ]),
                            (_unref(form).key_projects && _unref(form).key_projects.length > 1)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  onClick: ($event: any) => (removeProject(index)),
                                  type: "button",
                                  class: "border border-border rounded-md px-2 hover:bg-muted text-sm"
                                }, " ✕ ", 8, _hoisted_79))
                              : _createCommentVNode("", true)
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((project.location_label) = $event),
                            type: "text",
                            placeholder: "Project location",
                            onInput: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_unref(triggerAutosave) && _unref(triggerAutosave)(...args))),
                            class: "w-full border border-border rounded-md px-3 py-2 focus:ring-2 focus:ring-brand focus:border-transparent outline-none text-sm"
                          }, null, 40, _hoisted_80), [
                            [_vModelText, project.location_label]
                          ]),
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": ($event: any) => ((project.description) = $event),
                            rows: "3",
                            placeholder: "Project description",
                            onInput: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_unref(triggerAutosave) && _unref(triggerAutosave)(...args))),
                            class: "w-full border border-border rounded-md px-3 py-2 focus:ring-2 focus:ring-brand focus:border-transparent outline-none text-sm"
                          }, null, 40, _hoisted_81), [
                            [_vModelText, project.description]
                          ]),
                          (project.location_label)
                            ? (_openBlock(), _createBlock(GoogleMap, {
                                key: 0,
                                editable: "",
                                address: project.location_label,
                                lat: project.location_lat ?? null,
                                lng: project.location_lng ?? null,
                                "map-height-class": "h-40",
                                "onUpdate:location": ($event: any) => (updateProjectLocation(index, $event))
                              }, null, 8, ["address", "lat", "lng", "onUpdate:location"]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_82, [
                            _createElementVNode("div", _hoisted_83, [
                              _cache[84] || (_cache[84] = _createElementVNode("p", { class: "text-xs font-medium text-muted-foreground" }, "Activity feed", -1)),
                              _createElementVNode("button", {
                                type: "button",
                                class: "text-xs font-semibold text-brand hover:text-brand/80",
                                onClick: ($event: any) => (addProjectActivity(index))
                              }, " + Add update ", 8, _hoisted_84)
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(project.activity_feed, (activity, activityIndex) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: activityIndex,
                                class: "grid gap-2 sm:grid-cols-[150px,minmax(0,1fr),auto]"
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": ($event: any) => ((activity.date) = $event),
                                  type: "date",
                                  onChange: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_unref(triggerAutosave) && _unref(triggerAutosave)(...args))),
                                  class: "border border-border rounded-md px-3 py-2 focus:ring-2 focus:ring-brand focus:border-transparent outline-none text-sm"
                                }, null, 40, _hoisted_85), [
                                  [_vModelText, activity.date]
                                ]),
                                _withDirectives(_createElementVNode("textarea", {
                                  "onUpdate:modelValue": ($event: any) => ((activity.text) = $event),
                                  rows: "2",
                                  placeholder: "Market update",
                                  onInput: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_unref(triggerAutosave) && _unref(triggerAutosave)(...args))),
                                  class: "border border-border rounded-md px-3 py-2 focus:ring-2 focus:ring-brand focus:border-transparent outline-none text-sm"
                                }, null, 40, _hoisted_86), [
                                  [_vModelText, activity.text]
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "border border-border rounded-md px-2 text-sm hover:bg-muted",
                                  onClick: ($event: any) => (removeProjectActivity(index, activityIndex))
                                }, " ✕ ", 8, _hoisted_87)
                              ]))
                            }), 128))
                          ]),
                          _cache[85] || (_cache[85] = _createElementVNode("p", { class: "text-xs font-medium text-muted-foreground" }, "Project commodities", -1)),
                          _createElementVNode("div", _hoisted_88, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(COMMODITIES), (commodity) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: commodity,
                                type: "button",
                                onClick: ($event: any) => (toggleProjectCommodity(index, commodity)),
                                class: _normalizeClass(["rounded-full border px-3 py-1 text-xs transition-colors", project.commodities?.includes(commodity)
                    ? 'bg-brand text-white border-brand'
                    : 'border-border text-muted-foreground hover:border-brand hover:text-foreground'])
                              }, _toDisplayString(commodity), 11, _hoisted_89))
                            }), 128))
                          ])
                        ]))
                      }), 128)),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: addProject,
                        class: "w-full border border-dashed rounded-md py-2 text-sm text-muted-foreground hover:border-brand hover:text-foreground transition-colors"
                      }, " + Add Project ")
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_90, [
                _cache[87] || (_cache[87] = _createElementVNode("div", { class: "flex items-center gap-2 mb-2" }, [
                  _createElementVNode("label", { class: "font-medium text-sm" }, "Job Links"),
                  _createElementVNode("span", { class: "text-muted-foreground text-xs" }, "(optional)")
                ], -1)),
                _cache[88] || (_cache[88] = _createElementVNode("p", { class: "mb-4 text-sm text-muted-foreground" }, " Add any hiring destinations you want contractors to see on your company page. ", -1)),
                _createElementVNode("div", _hoisted_91, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(JOB_LINK_FIELDS, (jobLinkField) => {
                    return _createElementVNode("label", {
                      key: jobLinkField.type,
                      class: "block rounded-lg border border-border/60 bg-background/80 p-4 shadow-sm"
                    }, [
                      _createElementVNode("div", _hoisted_92, [
                        _createElementVNode("span", _hoisted_93, _toDisplayString(jobLinkField.label), 1),
                        _createElementVNode("span", _hoisted_94, _toDisplayString(jobLinkField.badge), 1)
                      ]),
                      _createElementVNode("input", {
                        value: getJobLinkUrl(jobLinkField.type),
                        type: "url",
                        placeholder: jobLinkField.placeholder,
                        onInput: ($event: any) => (handleJobLinkInput(jobLinkField.type, $event)),
                        class: "mt-3 w-full rounded-md border border-border bg-background px-3 py-2 text-sm focus:ring-1 focus:ring-brand outline-none"
                      }, null, 40, _hoisted_95),
                      _createElementVNode("p", _hoisted_96, _toDisplayString(jobLinkField.helpText), 1)
                    ])
                  }), 64))
                ])
              ]),
              (shouldShowMarketData.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                    _cache[113] || (_cache[113] = _createElementVNode("h3", { class: "text-sm font-medium mb-3" }, "Market Data", -1)),
                    _createElementVNode("div", _hoisted_98, [
                      _createElementVNode("div", _hoisted_99, [
                        _cache[91] || (_cache[91] = _createElementVNode("div", null, [
                          _createElementVNode("p", { class: "text-sm font-medium text-foreground" }, "Private company"),
                          _createElementVNode("p", { class: "text-xs text-muted-foreground" }, "Hide market data for private companies.")
                        ], -1)),
                        _createElementVNode("label", _hoisted_100, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_unref(form).is_private_company) = $event)),
                            type: "checkbox",
                            class: "sr-only peer",
                            onChange: handlePrivateToggle
                          }, null, 544), [
                            [_vModelCheckbox, _unref(form).is_private_company]
                          ]),
                          _cache[89] || (_cache[89] = _createElementVNode("div", { class: "h-6 w-11 rounded-full border border-border bg-muted/40 transition-colors peer-checked:bg-brand peer-focus-visible:ring-2 peer-focus-visible:ring-brand/40" }, null, -1)),
                          _cache[90] || (_cache[90] = _createElementVNode("div", { class: "absolute left-1 top-1 h-4 w-4 rounded-full bg-white shadow transition-transform peer-checked:translate-x-5" }, null, -1))
                        ])
                      ]),
                      _createElementVNode("label", _hoisted_101, [
                        _cache[93] || (_cache[93] = _createElementVNode("span", { class: "text-sm font-medium" }, "ASX Ticker", -1)),
                        _createElementVNode("div", _hoisted_102, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_unref(form).ticker) = $event)),
                            type: "text",
                            maxlength: "5",
                            inputmode: "text",
                            placeholder: "e.g., BHP",
                            disabled: _unref(form).is_private_company,
                            onInput: handleTickerInput,
                            class: "w-full rounded-md border border-border bg-background px-3 py-2 text-sm focus:ring-1 focus:ring-brand outline-none uppercase disabled:bg-muted/40 disabled:text-muted-foreground"
                          }, null, 40, _hoisted_103), [
                            [_vModelText, _unref(form).ticker]
                          ]),
                          (_unref(isFetchingMarketCap))
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_104, _cache[92] || (_cache[92] = [
                                _createElementVNode("circle", {
                                  cx: "12",
                                  cy: "12",
                                  r: "10"
                                }, null, -1),
                                _createElementVNode("path", { d: "M4 12a8 8 0 018-8" }, null, -1)
                              ])))
                            : _createCommentVNode("", true)
                        ]),
                        (_unref(marketCapError))
                          ? (_openBlock(), _createElementBlock("p", _hoisted_105, _toDisplayString(_unref(marketCapError)), 1))
                          : (_openBlock(), _createElementBlock("p", _hoisted_106, " Market cap is fetched automatically from the ASX ticker. If you’re not listed, mark the company as private. "))
                      ]),
                      (_unref(form).market_cap)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                            _cache[94] || (_cache[94] = _createElementVNode("span", { class: "text-sm font-medium" }, "Market Cap (auto)", -1)),
                            _createElementVNode("div", _hoisted_108, _toDisplayString(_unref(form).market_cap), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("label", _hoisted_109, [
                        _cache[96] || (_cache[96] = _createElementVNode("span", { class: "text-sm font-medium" }, "Cash in Bank (AUD)", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_unref(form).cash_in_bank) = $event)),
                          type: "text",
                          inputmode: "decimal",
                          onInput: handleCashInBankInput,
                          class: "mt-1 w-full rounded-md border border-border bg-background px-3 py-2 text-sm focus:ring-1 focus:ring-brand outline-none text-right",
                          placeholder: "e.g. 2,000,000"
                        }, null, 544), [
                          [_vModelText, _unref(form).cash_in_bank]
                        ]),
                        (hasCashInBankValue.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                              _cache[95] || (_cache[95] = _createElementVNode("span", { class: "block text-xs font-medium mb-1 text-muted-foreground" }, "Date of Balance", -1)),
                              _createVNode(_unref(VueDatePicker), {
                                modelValue: _unref(form).cash_in_bank_updated_at,
                                "onUpdate:modelValue": [
                                  _cache[38] || (_cache[38] = ($event: any) => ((_unref(form).cash_in_bank_updated_at) = $event)),
                                  _unref(triggerAutosave)
                                ],
                                "enable-time-picker": false,
                                "auto-apply": "",
                                teleport: "",
                                "model-type": "yyyy-MM-dd",
                                format: "dd/MM/yyyy",
                                placeholder: "Select date",
                                "input-class": [
                    'w-full h-10 rounded-md border border-border text-foreground px-3 text-sm focus:ring-2 focus:ring-brand focus:border-brand bg-background',
                  ],
                                "menu-class": ['rounded-lg shadow-lg border border-border bg-background']
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("label", _hoisted_111, [
                        _cache[97] || (_cache[97] = _createElementVNode("span", { class: "text-sm font-medium" }, "Cash Runway", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_unref(form).cash_runway) = $event)),
                          type: "text",
                          inputmode: "decimal",
                          onInput: handleCashRunwayInput,
                          class: "mt-1 w-full rounded-md border border-border bg-background px-3 py-2 text-sm focus:ring-1 focus:ring-brand outline-none",
                          placeholder: "e.g. 4 or 4.5"
                        }, null, 544), [
                          [_vModelText, _unref(form).cash_runway]
                        ]),
                        (cashRunwayError.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_112, _toDisplayString(cashRunwayError.value), 1))
                          : _createCommentVNode("", true),
                        _cache[98] || (_cache[98] = _createElementVNode("p", { class: "mt-1 text-xs text-muted-foreground" }, " Estimated time (in quarters) a company can operate using current cash, based on recent spend ", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_113, [
                      _cache[105] || (_cache[105] = _createElementVNode("div", { class: "flex items-center gap-2 mb-2" }, [
                        _createElementVNode("label", { class: "font-medium text-sm" }, "Recent Capital Raisings"),
                        _createElementVNode("span", { class: "text-muted-foreground text-xs" }, "(optional)")
                      ], -1)),
                      _cache[106] || (_cache[106] = _createElementVNode("p", { class: "mb-4 text-sm text-muted-foreground" }, " Track recent placements, raises, or other funding events with a short source-backed summary. ", -1)),
                      _createElementVNode("div", _hoisted_114, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(form).recent_capital_raisings, (raising, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "rounded-lg border border-border/60 bg-background/80 p-4 shadow-sm space-y-3"
                          }, [
                            _createElementVNode("div", _hoisted_115, [
                              _createElementVNode("label", _hoisted_116, [
                                _cache[99] || (_cache[99] = _createElementVNode("span", { class: "mb-1 block text-xs font-medium uppercase tracking-[0.12em] text-muted-foreground" }, "Date", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": ($event: any) => ((raising.date) = $event),
                                  onInput: _cache[40] || (_cache[40] = 
//@ts-ignore
(...args) => (_unref(triggerAutosave) && _unref(triggerAutosave)(...args))),
                                  type: "date",
                                  class: "w-full border border-border rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-brand focus:border-transparent outline-none"
                                }, null, 40, _hoisted_117), [
                                  [_vModelText, raising.date]
                                ])
                              ]),
                              _createElementVNode("label", _hoisted_118, [
                                _cache[100] || (_cache[100] = _createElementVNode("span", { class: "mb-1 block text-xs font-medium uppercase tracking-[0.12em] text-muted-foreground" }, "Amount Raised (AUD)", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": ($event: any) => ((raising.amount) = $event),
                                  onInput: ($event: any) => (handleCapitalRaisingAmountInput(index)),
                                  type: "text",
                                  inputmode: "decimal",
                                  placeholder: "e.g. 12,000,000",
                                  class: "w-full border border-border rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-brand focus:border-transparent outline-none"
                                }, null, 40, _hoisted_119), [
                                  [_vModelText, raising.amount]
                                ])
                              ]),
                              _createElementVNode("label", _hoisted_120, [
                                _cache[101] || (_cache[101] = _createElementVNode("span", { class: "mb-1 block text-xs font-medium uppercase tracking-[0.12em] text-muted-foreground" }, "Type", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": ($event: any) => ((raising.label) = $event),
                                  onInput: _cache[41] || (_cache[41] = 
//@ts-ignore
(...args) => (_unref(triggerAutosave) && _unref(triggerAutosave)(...args))),
                                  type: "text",
                                  placeholder: "e.g. Placement",
                                  class: "w-full border border-border rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-brand focus:border-transparent outline-none"
                                }, null, 40, _hoisted_121), [
                                  [_vModelText, raising.label]
                                ])
                              ]),
                              _createElementVNode("label", _hoisted_122, [
                                _cache[102] || (_cache[102] = _createElementVNode("span", { class: "mb-1 block text-xs font-medium uppercase tracking-[0.12em] text-muted-foreground" }, "Source URL", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": ($event: any) => ((raising.url) = $event),
                                  onInput: _cache[42] || (_cache[42] = 
//@ts-ignore
(...args) => (_unref(triggerAutosave) && _unref(triggerAutosave)(...args))),
                                  type: "url",
                                  placeholder: "Announcement or source URL",
                                  class: "w-full border border-border rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-brand focus:border-transparent outline-none"
                                }, null, 40, _hoisted_123), [
                                  [_vModelText, raising.url]
                                ])
                              ]),
                              _createElementVNode("label", _hoisted_124, [
                                _cache[103] || (_cache[103] = _createElementVNode("span", { class: "mb-1 block text-xs font-medium uppercase tracking-[0.12em] text-muted-foreground" }, "Summary", -1)),
                                _withDirectives(_createElementVNode("textarea", {
                                  "onUpdate:modelValue": ($event: any) => ((raising.summary) = $event),
                                  onInput: _cache[43] || (_cache[43] = 
//@ts-ignore
(...args) => (_unref(triggerAutosave) && _unref(triggerAutosave)(...args))),
                                  rows: "3",
                                  placeholder: "Short summary",
                                  class: "w-full border border-border rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-brand focus:border-transparent outline-none resize-none"
                                }, null, 40, _hoisted_125), [
                                  [_vModelText, raising.summary]
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_126, [
                              _createElementVNode("button", {
                                onClick: ($event: any) => (removeCapitalRaising(index)),
                                class: "inline-flex items-center gap-1 rounded-md border border-border px-2.5 py-1 text-xs font-medium text-muted-foreground transition hover:border-brand hover:text-foreground",
                                type: "button"
                              }, _cache[104] || (_cache[104] = [
                                _createElementVNode("span", null, "Remove", -1)
                              ]), 8, _hoisted_127)
                            ])
                          ]))
                        }), 128)),
                        _createElementVNode("button", {
                          type: "button",
                          onClick: addCapitalRaising,
                          class: "w-full border border-dashed rounded-md py-2 text-sm text-muted-foreground hover:border-brand hover:text-foreground transition-colors"
                        }, " + Add Capital Raising ")
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_128, [
                      _cache[111] || (_cache[111] = _createElementVNode("div", { class: "flex items-center gap-2 mb-2" }, [
                        _createElementVNode("label", { class: "font-medium text-sm" }, "Benefits"),
                        _createElementVNode("span", { class: "text-muted-foreground text-xs" }, "(optional)")
                      ], -1)),
                      _cache[112] || (_cache[112] = _createElementVNode("p", { class: "mb-4 text-sm text-muted-foreground" }, " Add contractor-facing benefits and where the information came from, for example Seek. ", -1)),
                      _createElementVNode("div", _hoisted_129, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(form).benefits, (benefit, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "rounded-lg border border-border/60 bg-background/80 p-4 shadow-sm space-y-3"
                          }, [
                            _createElementVNode("div", _hoisted_130, [
                              _createElementVNode("label", _hoisted_131, [
                                _cache[107] || (_cache[107] = _createElementVNode("span", { class: "mb-1 block text-xs font-medium uppercase tracking-[0.12em] text-muted-foreground" }, "Heading", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": ($event: any) => ((benefit.heading) = $event),
                                  onInput: _cache[44] || (_cache[44] = 
//@ts-ignore
(...args) => (_unref(triggerAutosave) && _unref(triggerAutosave)(...args))),
                                  type: "text",
                                  placeholder: "e.g. Salary packaging",
                                  class: "w-full border border-border rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-brand focus:border-transparent outline-none"
                                }, null, 40, _hoisted_132), [
                                  [_vModelText, benefit.heading]
                                ])
                              ]),
                              _createElementVNode("label", _hoisted_133, [
                                _cache[108] || (_cache[108] = _createElementVNode("span", { class: "mb-1 block text-xs font-medium uppercase tracking-[0.12em] text-muted-foreground" }, "Source", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": ($event: any) => ((benefit.source) = $event),
                                  onInput: _cache[45] || (_cache[45] = 
//@ts-ignore
(...args) => (_unref(triggerAutosave) && _unref(triggerAutosave)(...args))),
                                  type: "text",
                                  placeholder: "e.g. Seek",
                                  class: "w-full border border-border rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-brand focus:border-transparent outline-none"
                                }, null, 40, _hoisted_134), [
                                  [_vModelText, benefit.source]
                                ])
                              ]),
                              _createElementVNode("label", _hoisted_135, [
                                _cache[109] || (_cache[109] = _createElementVNode("span", { class: "mb-1 block text-xs font-medium uppercase tracking-[0.12em] text-muted-foreground" }, "Short Description", -1)),
                                _withDirectives(_createElementVNode("textarea", {
                                  "onUpdate:modelValue": ($event: any) => ((benefit.description) = $event),
                                  onInput: _cache[46] || (_cache[46] = 
//@ts-ignore
(...args) => (_unref(triggerAutosave) && _unref(triggerAutosave)(...args))),
                                  rows: "3",
                                  placeholder: "Short description of the benefit",
                                  class: "w-full border border-border rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-brand focus:border-transparent outline-none resize-none"
                                }, null, 40, _hoisted_136), [
                                  [_vModelText, benefit.description]
                                ])
                              ])
                            ]),
                            (benefit.added_at)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_137, " Added " + _toDisplayString(_unref(formatDateAsDayMonthYear)(benefit.added_at)), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_138, [
                              _createElementVNode("button", {
                                onClick: ($event: any) => (removeBenefit(index)),
                                class: "inline-flex items-center gap-1 rounded-md border border-border px-2.5 py-1 text-xs font-medium text-muted-foreground transition hover:border-brand hover:text-foreground",
                                type: "button"
                              }, _cache[110] || (_cache[110] = [
                                _createElementVNode("span", null, "Remove", -1)
                              ]), 8, _hoisted_139)
                            ])
                          ]))
                        }), 128)),
                        _createElementVNode("button", {
                          type: "button",
                          onClick: addBenefit,
                          class: "w-full border border-dashed rounded-md py-2 text-sm text-muted-foreground hover:border-brand hover:text-foreground transition-colors"
                        }, " + Add Benefit ")
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("section", _hoisted_140, [
              _cache[119] || (_cache[119] = _createElementVNode("h2", {
                id: "sec-operations-title",
                class: "text-lg font-semibold"
              }, "Operations Overview", -1)),
              _createElementVNode("div", _hoisted_141, [
                (shouldShowMiningOperations.value)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_142, [
                      _cache[115] || (_cache[115] = _createElementVNode("span", { class: "text-sm font-medium" }, "Field Roster", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        onInput: _cache[47] || (_cache[47] = 
//@ts-ignore
(...args) => (_unref(triggerAutosave) && _unref(triggerAutosave)(...args))),
                        "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_unref(form).field_roster) = $event)),
                        class: "mt-1 min-h-24 w-full rounded-md border border-border bg-background px-3 py-2 text-sm focus:ring-1 focus:ring-brand outline-none",
                        placeholder: "e.g., 2 weeks on / 1 week off"
                      }, null, 544), [
                        [_vModelText, _unref(form).field_roster]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("label", _hoisted_143, [
                  _cache[116] || (_cache[116] = _createElementVNode("span", { class: "text-sm font-medium" }, "Typical Hours", -1)),
                  _withDirectives(_createElementVNode("input", {
                    onInput: _cache[49] || (_cache[49] = 
//@ts-ignore
(...args) => (_unref(triggerAutosave) && _unref(triggerAutosave)(...args))),
                    "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_unref(form).typical_hours) = $event)),
                    class: "mt-1 w-full rounded-md border border-border bg-background px-3 py-2 text-sm focus:ring-1 focus:ring-brand outline-none",
                    placeholder: "e.g., 12-hour shifts"
                  }, null, 544), [
                    [_vModelText, _unref(form).typical_hours]
                  ])
                ]),
                (shouldShowMiningOperations.value)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_144, [
                      _cache[117] || (_cache[117] = _createElementVNode("span", { class: "text-sm font-medium" }, "Facilities", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        onInput: _cache[51] || (_cache[51] = 
//@ts-ignore
(...args) => (_unref(triggerAutosave) && _unref(triggerAutosave)(...args))),
                        "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_unref(form).facilities) = $event)),
                        class: "mt-1 min-h-24 w-full rounded-md border border-border bg-background px-3 py-2 text-sm focus:ring-1 focus:ring-brand outline-none",
                        placeholder: "Accommodation camps, processing plant..."
                      }, null, 544), [
                        [_vModelText, _unref(form).facilities]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                  _cache[118] || (_cache[118] = _createElementVNode("span", { class: "text-sm font-medium" }, "Software Used", -1)),
                  _createVNode(TagAutocomplete, {
                    modelValue: softwareSelection.value,
                    "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((softwareSelection).value = $event)),
                    options: softwareOptions.value,
                    placeholder: "Search software or add your own",
                    clearable: ""
                  }, null, 8, ["modelValue", "options"])
                ])
              ])
            ]),
            _createElementVNode("section", _hoisted_145, [
              _cache[120] || (_cache[120] = _createElementVNode("div", { class: "flex items-center gap-2 mb-2" }, [
                _createElementVNode("label", { class: "font-medium text-sm" }, "Social Media"),
                _createElementVNode("span", { class: "text-muted-foreground text-xs" }, "(optional)")
              ], -1)),
              _cache[121] || (_cache[121] = _createElementVNode("p", { class: "mb-4 text-sm text-muted-foreground" }, " Add the main social channels you want candidates to use when researching your company. ", -1)),
              _createElementVNode("div", _hoisted_146, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(SOCIAL_LINK_FIELDS, (socialField) => {
                  return _createElementVNode("label", {
                    key: socialField.type,
                    class: "block rounded-lg border border-border/60 bg-background/80 p-4 shadow-sm"
                  }, [
                    _createElementVNode("span", _hoisted_147, _toDisplayString(socialField.label), 1),
                    _createElementVNode("input", {
                      value: getSocialLinkUrl(socialField.type),
                      type: "url",
                      placeholder: socialField.placeholder,
                      onInput: ($event: any) => (handleSocialLinkInput(socialField.type, $event)),
                      class: "mt-3 w-full rounded-md border border-border bg-background px-3 py-2 text-sm focus:ring-1 focus:ring-brand outline-none"
                    }, null, 40, _hoisted_148),
                    _createElementVNode("p", _hoisted_149, _toDisplayString(socialField.helpText), 1)
                  ])
                }), 64))
              ])
            ]),
            _cache[122] || (_cache[122] = _createElementVNode("div", { class: "h-8" }, null, -1))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_150, _cache[123] || (_cache[123] = [
            _createStaticVNode("<section class=\"rounded-lg border border-border bg-card p-6\" data-v-56c31c1d><div class=\"h-5 w-40 rounded bg-muted\" data-v-56c31c1d></div><div class=\"mt-6 grid gap-4 md:grid-cols-2\" data-v-56c31c1d><div class=\"h-4 w-full rounded bg-muted\" data-v-56c31c1d></div><div class=\"h-4 w-full rounded bg-muted\" data-v-56c31c1d></div><div class=\"md:col-span-2 space-y-4\" data-v-56c31c1d><div class=\"h-3 w-full rounded bg-muted\" data-v-56c31c1d></div><div class=\"h-3 w-3/4 rounded bg-muted\" data-v-56c31c1d></div><div class=\"h-3 w-1/2 rounded bg-muted\" data-v-56c31c1d></div></div></div></section><section class=\"rounded-lg border border-border bg-card p-6\" data-v-56c31c1d><div class=\"h-5 w-48 rounded bg-muted\" data-v-56c31c1d></div><div class=\"mt-6 space-y-4\" data-v-56c31c1d><div class=\"h-3 w-full rounded bg-muted\" data-v-56c31c1d></div><div class=\"h-3 w-5/6 rounded bg-muted\" data-v-56c31c1d></div><div class=\"h-3 w-2/3 rounded bg-muted\" data-v-56c31c1d></div></div></section><section class=\"rounded-lg border border-border bg-card p-6\" data-v-56c31c1d><div class=\"h-5 w-56 rounded bg-muted\" data-v-56c31c1d></div><div class=\"mt-6 space-y-3\" data-v-56c31c1d><div class=\"h-3 w-full rounded bg-muted\" data-v-56c31c1d></div><div class=\"h-3 w-5/6 rounded bg-muted\" data-v-56c31c1d></div><div class=\"h-3 w-4/6 rounded bg-muted\" data-v-56c31c1d></div></div></section>", 3)
          ])))
    ]),
    _createVNode(_Transition, {
      "enter-active-class": "transition duration-300 ease-out",
      "enter-from-class": "opacity-0 -translate-y-3 scale-[0.98]",
      "enter-to-class": "opacity-100 translate-y-0 scale-100",
      "leave-active-class": "transition duration-200 ease-in",
      "leave-from-class": "opacity-100 translate-y-0",
      "leave-to-class": "opacity-0 -translate-y-2"
    }, {
      default: _withCtx(() => [
        (publishNotice.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_151, [
              _createElementVNode("div", _hoisted_152, [
                _createElementVNode("div", _hoisted_153, [
                  _createVNode(_unref(Sparkles), { class: "h-6 w-6" })
                ]),
                _createElementVNode("div", _hoisted_154, [
                  _createElementVNode("p", _hoisted_155, _toDisplayString(publishNotice.value.headline), 1),
                  _createElementVNode("p", _hoisted_156, _toDisplayString(publishNotice.value.message), 1),
                  (publishNotice.value.chips.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_157, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(publishNotice.value.chips, (chip) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: chip.id,
                            type: "button",
                            class: "group inline-flex items-center gap-2 rounded-full border border-brand/20 bg-brand/10 px-3 py-1 text-xs font-medium text-brand transition hover:border-brand/30 hover:bg-brand/15",
                            onClick: ($event: any) => (handleChipClick(chip))
                          }, [
                            _cache[124] || (_cache[124] = _createElementVNode("span", { class: "h-1.5 w-1.5 rounded-full bg-brand transition group-hover:bg-brand/80" }, null, -1)),
                            _createElementVNode("span", null, _toDisplayString(chip.label), 1)
                          ], 8, _hoisted_158))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_159, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "rounded-full p-1 text-muted-foreground transition hover:bg-muted/40 hover:text-foreground",
                    onClick: dismissPublishNotice,
                    "aria-label": "Dismiss publish warning"
                  }, [
                    _createVNode(_unref(X), { class: "h-4 w-4" })
                  ]),
                  (publishNotice.value.primaryAnchor)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "inline-flex items-center gap-2 rounded-full bg-brand px-3.5 py-1.5 text-xs font-semibold text-white shadow-sm transition hover:bg-brand/90",
                        onClick: handleReviewIssues
                      }, [
                        _cache[125] || (_cache[125] = _createTextVNode(" Review now ")),
                        _createVNode(_unref(ArrowRight), { class: "h-3.5 w-3.5" })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _cache[126] || (_cache[126] = _createElementVNode("span", { class: "pointer-events-none absolute inset-x-10 -bottom-2 h-[3px] rounded-full bg-brand/40" }, null, -1))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      "enter-active-class": "transition duration-200 ease-out",
      "enter-from-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "transition duration-150 ease-in",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        (showDiscardModal.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-[1100] flex items-center justify-center bg-black/60 px-4",
              onClick: _withModifiers(closeDiscardModal, ["self"])
            }, [
              _createElementVNode("div", _hoisted_160, [
                _createElementVNode("div", _hoisted_161, [
                  _cache[127] || (_cache[127] = _createElementVNode("h3", { class: "text-lg font-semibold text-foreground" }, "Discard draft?", -1)),
                  _cache[128] || (_cache[128] = _createElementVNode("p", { class: "mt-2 text-sm text-muted-foreground" }, " This will delete your saved draft and reload the latest published company profile. ", -1)),
                  (discardError.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_162, _toDisplayString(discardError.value), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_163, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "px-4 py-2 text-sm font-medium text-muted-foreground hover:text-foreground",
                    onClick: closeDiscardModal,
                    disabled: isDiscarding.value
                  }, " Cancel ", 8, _hoisted_164),
                  _createElementVNode("button", {
                    type: "button",
                    class: "inline-flex items-center gap-2 rounded-md bg-destructive px-4 py-2 text-sm font-medium text-white shadow-sm transition hover:bg-destructive/90 disabled:opacity-60 disabled:cursor-not-allowed",
                    onClick: confirmDiscard,
                    disabled: isDiscarding.value
                  }, [
                    (isDiscarding.value)
                      ? (_openBlock(), _createBlock(_unref(Loader2), {
                          key: 0,
                          class: "h-4 w-4 animate-spin"
                        }))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, _toDisplayString(isDiscarding.value ? 'Discarding…' : 'Discard draft'), 1)
                  ], 8, _hoisted_165)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      "enter-active-class": "transition duration-200 ease-out",
      "enter-from-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "transition duration-150 ease-in",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        (showPublishModal.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-[1100] flex items-center justify-center bg-black/60 px-4",
              onClick: _withModifiers(closePublishModal, ["self"])
            }, [
              _createElementVNode("div", _hoisted_166, [
                _createElementVNode("div", _hoisted_167, [
                  _createElementVNode("div", _hoisted_168, [
                    _createElementVNode("div", _hoisted_169, [
                      _createVNode(_unref(Sparkles), { class: "h-5 w-5" })
                    ]),
                    _cache[129] || (_cache[129] = _createElementVNode("div", null, [
                      _createElementVNode("h3", { class: "text-lg font-semibold text-foreground" }, "Publish company profile?"),
                      _createElementVNode("p", { class: "text-sm text-muted-foreground" }, " Your updates will go live immediately and the draft will be cleared. ")
                    ], -1))
                  ]),
                  _createElementVNode("ul", _hoisted_170, [
                    _createElementVNode("li", _hoisted_171, [
                      _createVNode(_unref(CheckCircle2), { class: "h-4 w-4 text-brand" }),
                      _cache[130] || (_cache[130] = _createTextVNode(" All required sections look good. "))
                    ]),
                    _createElementVNode("li", _hoisted_172, [
                      _createVNode(_unref(CheckCircle2), { class: "h-4 w-4 text-brand" }),
                      _cache[131] || (_cache[131] = _createTextVNode(" We’ll overwrite your published profile and remove the draft. "))
                    ])
                  ]),
                  (publishError.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_173, _toDisplayString(publishError.value), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_174, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "px-4 py-2 text-sm font-medium text-muted-foreground hover:text-foreground",
                    onClick: closePublishModal,
                    disabled: isPublishing.value
                  }, " Cancel ", 8, _hoisted_175),
                  _createElementVNode("button", {
                    type: "button",
                    class: "inline-flex items-center gap-2 rounded-md bg-brand px-4 py-2 text-sm font-medium text-white shadow-sm transition hover:bg-brand/90 disabled:opacity-60 disabled:cursor-not-allowed",
                    onClick: confirmPublish,
                    disabled: isPublishing.value
                  }, [
                    (isPublishing.value)
                      ? (_openBlock(), _createBlock(_unref(Loader2), {
                          key: 0,
                          class: "h-4 w-4 animate-spin"
                        }))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, _toDisplayString(isPublishing.value ? 'Publishing…' : 'Publish profile'), 1)
                  ], 8, _hoisted_176)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(SaveStatusToast, { status: _unref(saveStatus) }, null, 8, ["status"])
  ]))
}
}

})